import axios from "axios";
import { API_BASE_URL } from "./api.config";
import { handleError } from "./error/errorHandler";

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Sync headers with sessionStorage on every request
api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem("satiAuth");
    if (token) {
      config.headers["sessiontoken"] = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for global error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const errorInfo = handleError(error);

    // Handle 401 Unauthorized
    if (errorInfo.status === 401) {
      // Possible future action: trigger logout or token refresh
      // authService.logout();
      // window.location.href = "/login";
    }

    // Always reject with the enriched errorInfo for better consumer handling
    return Promise.reject(errorInfo);
  }
);

export default api;
